import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { scrollToId } from "@/lib/scroll";
import { WhatsAppIcon, WA_LINK } from "@/components/WhatsAppFloat";

export const StickyCta = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-40 border-t border-line px-4 py-3 backdrop-blur-xl md:hidden"
          style={{ backgroundColor: "rgba(250,248,245,0.92)" }}
        >
          <div className="flex items-center gap-3">
            <button
              data-testid="sticky-mobile-cta-button"
              onClick={() => scrollToId("yhteydenotto")}
              className="flex-1 rounded-full bg-petrol py-3.5 text-center text-[0.95rem] font-semibold text-cream"
            >
              Ota yhteyttä
            </button>
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="sticky-mobile-whatsapp-link"
              aria-label="Avaa WhatsApp-chat"
              className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#1FA855] text-white"
            >
              <WhatsAppIcon className="h-6 w-6" />
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
